import Icons from "@/src/components/Icons";
import Modal from "@/src/components/Modal";
interface itemProps {
  open: any;
  close: any;
  data: any;
}
import iran from "../../assets/img/iran.png";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import classNames from "classnames";
import moment from "jalali-moment";
const processLicensePlate = (plate: any) => {
  if (!plate) return null;

  if (plate.includes("ایران")) {
    const parts = plate.split(" ");
    const iranIndex = parts.findIndex((p: any) => p === "ایران");

    if (iranIndex > 0 && iranIndex < parts.length - 1) {
      const stateNumber = parts[iranIndex + 1];
      const mainPlate = parts.slice(0, iranIndex).join(" ");

      return {
        type: "iranian",
        stateNumber,
        mainPlate,
      };
    }
  }

  if (/^\d+$/.test(plate)) {
    return {
      type: "numeric",
      plate,
    };
  }

  return {
    type: "unknown",
    plate,
  };
};

function ShippingItemModal({ open, close, data }: itemProps) {
  const status = data && data.status && data.status.code;

  const processedPlate =
    data && data.courierVehiclePlate
      ? processLicensePlate(data.courierVehiclePlate)
      : null;
  const classBadge = classNames({
    "h-[36px] w-[125px] flex items-center justify-center text-white rounded-2xl mt-3 text-sm":
      true,
    "bg-success": status === "DELIVERED" || status === "DELIVERING",
    "bg-error": status === "CANCELLED",
    "bg-done": status === "PICKING",
  });

  return (
    <Modal open={open} onClose={close}>
      <h4 className="text-xl font-bold">
        {data && data.receiverAddress && data.receiverAddress.addressOwnerName}
      </h4>
      <div className="flex w-full justify-start flex-col">
        <div className="shadow-mmpz rounded-xl gap-2 p-2 flex mt-4 ">
          <span className="flex items-center gap-2">
            <Icons name="time" />
            {data &&
              data.date &&
              digitsEnToFa(moment(data.date).format("HH:mm"))}
          </span>
          <span className="flex items-center gap-2 text-gray-200-mmpz">
            <Icons name="date" fill="none" />
            {data && data.date && digitsEnToFa(moment(data.date).format("ddd"))}
          </span>
          <span className="flex items-center gap-2 text-gray-200-mmpz">
            {data &&
              data.date &&
              digitsEnToFa(moment(data.date).format("jDD-jMM-jYYYY"))}
          </span>
        </div>
        <span className={classBadge}>
          {data && data.status && data.status.name}
        </span>
        <p className="flex gap-2 mt-5 items-center w-full mb-4">
          <div className="w-1/12">
            <Icons name="location" fill="none" size={20} />
          </div>
          <span className="text-sm text-[#4B4B4B]  ">
            {data && data.receiverAddress && data.receiverAddress.fullAddress}
          </span>{" "}
        </p>
        <p className="font-bold my-2">مشخصات راننده</p>
        <div className="w-full shadow-mmpz rounded-xl gap-2 p-2 flex mt-4">
          <div className="item w-1/2 flex flex-col gap-4">
            <span
              className={`flex items-center gap-2 text-sm ${
                data && data.provider && data.provider.code === "TAPSI"
                  ? "text-primary-300"
                  : data && data.provider && data.provider.code === "SNAPP_BOX"
                  ? "text-[#00D170]"
                  : "text-[#0099FF]"
              }`}
            >
              <Icons name="car" /> {data && data.provider && data.provider.name}
            </span>
            <span className="flex items-center gap-2  text-sm">
              <Icons name="deliveryModel" size={28} />{" "}
              {data && data.courierVehicleName && data.courierVehicleName}
            </span>
            <span className="flex items-center gap-2  text-sm">
              <Icons name="tel" size={28} fill="none" />{" "}
              {data &&
                data.courierPhoneNumber &&
                digitsEnToFa(data.courierPhoneNumber)}
            </span>
            <span className="flex items-center gap-2  text-sm">
              <Icons name="user" size={28} fill="none" />{" "}
              {data && data.courierName && data.courierName}
            </span>
          </div>
          <div className="item w-1/2 border-r px-2 border-r-gray-100-mmpz flex justify-center items-center">
            <div className="border w-full rounded-md py-0 px-0 flex shadow-mmpz">
              {processedPlate ? (
                processedPlate.type === "iranian" ? (
                  <>
                    <div className="item w-3/12 border-l py-2 text-center flex flex-col items-center justify-center">
                      <span className="text-xs">ایران</span>
                      <span className="text-sm">
                        {digitsEnToFa(processedPlate.stateNumber)}
                      </span>
                    </div>
                    <div className="item w-6/12 py-2 text-center px-1 text-sm items-center flex justify-center whitespace-nowrap">
                      {digitsEnToFa(processedPlate.mainPlate)}
                    </div>
                  </>
                ) : (
                  <div className="item w-9/12 py-2 border-l text-center px-1 text-sm items-center flex justify-center">
                    {digitsEnToFa(processedPlate.plate)}
                  </div>
                )
              ) : (
                <div className="item w-9/12 py-2 border-l text-center px-1 text-sm items-center flex justify-center">
                  شماره پلاک نامشخص
                </div>
              )}
              <div className="item w-3/12 py-2 border-r bg-done flex flex-col items-end px-1">
                <img src={iran} width={18} />
                <span className="text-xs text-white">IR</span>
                <span className="text-xs text-white">IRAN</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ShippingItemModal;
